import { render, staticRenderFns } from "./GoodsAndImagePictureSelector.vue?vue&type=template&id=12650b19&scoped=true"
import script from "./GoodsAndImagePictureSelector.vue?vue&type=script&lang=js"
export * from "./GoodsAndImagePictureSelector.vue?vue&type=script&lang=js"
import style0 from "./GoodsAndImagePictureSelector.vue?vue&type=style&index=0&id=12650b19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12650b19",
  null
  
)

export default component.exports